const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/config/route.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/config/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/config')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});